<template>
  <MgdSidebar class="print:hidden">
    <MgdSidebarHeader v-if="!isMobile" class="h-12">
      <div
        class="relative h-full [&_svg]:absolute [&_svg]:h-full [&_svg]:w-full [&_svg]:transition-opacity"
      >
        <Icon
          name="mgd:midland"
          class="text-primary group-data-[state=collapsed]:opacity-0"
        />
        <Icon
          name="mgd:midland-m"
          class="text-primary group-data-[state=expanded]:opacity-0"
        />
      </div>
      <span class="sr-only">Midland Garage Door Dealer Portal</span>
    </MgdSidebarHeader>

    <MgdSidebarContent
      class="transition-transform group-data-[state=collapsed]:translate-y-6"
    >
      <SidebarCustomer />
      <SidebarCustomerAdmin />
      <SidebarAdmin />
    </MgdSidebarContent>

    <MgdSidebarFooter>
      <SidebarUser />
    </MgdSidebarFooter>
    <MgdSidebarRail v-if="!isMobile" />
  </MgdSidebar>
</template>

<script lang="ts" setup>
import { useSidebar } from "~/components/ui/sidebar";

const { isMobile } = useSidebar();
</script>
